/**
 * @owner @Appboy/in-app-messages
 */

// hand-written: no production samples yet, shaped from TrackedUserBehavior::DisplayImmediately#as_json

import { z } from "zod";

export const displayImmediatelyTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::DisplayImmediately"),
  type: z.literal("immediate"),
});
